import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchCurrentStep, fetchTabList } from "CourseAction";
import { fetchAllSpeakers } from "ActionsSpeakers";
import { fetchUserInterests } from "ActionsMessage";
import { fetchAllTickets } from "TicketAction";
import { fetchAllUnpublishedCourses } from "CourseAction";

import Navigation from "./navigation";
import CourseDetails from "../course/add-course-details";
import LessonsDetails from "../course/course-chapters-details";
import AddCoursePrice from "../course/add-course-price";
import PublishCourse from "../course/course-publish";
import LocaleStrings from "Languages";

class CourseWizard extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    let tabs = [
      { tab: "step_1", tabname: LocaleStrings.course_wizard_tab_1 },
      { tab: "step_2", tabname: LocaleStrings.course_wizard_tab_2 },
      { tab: "step_3", tabname: LocaleStrings.course_wizard_tab_4 },
      { tab: "step_4", tabname: LocaleStrings.course_wizard_tab_5 },
    ];
    this.props.fetchCurrentStep("step_1");
    this.props.fetchTabList(tabs);
    this.props.fetchAllSpeakers(this.props.session);
    this.props.fetchUserInterests(this.props.session);
    this.props.fetchAllTickets(this.props.session);
    this.props.fetchAllUnpublishedCourses(this.props.session);
  }

  render() {
    let { courseWizardStep, deviceSize } = this.props;

    return (
      <div
        className="panel-body scrollable-content"
        // style={{ height: deviceSize.height - 70 }}
      >
        <Navigation />
        <div className="row m-0">
          <div className="col-xl-9 col-lg-9 col-md-12 p-0">
            <div className="course-main-container">
              {courseWizardStep == "step_1" ? (
                <CourseDetails />
              ) : courseWizardStep == "step_2" ? (
                <LessonsDetails source="main-page" />
              ) : courseWizardStep == "step_3" ? (
                <AddCoursePrice />
              ) : courseWizardStep == "step_4" ? (
                <PublishCourse />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {


  return {
    session: state.session,
    courseWizardStep: state.courseWizardStep,
    allSpeakers: state.allSpeakers,
    deviceSize: state.deviceSize,
  };
}

export default connect(mapStateToProps, {
  fetchCurrentStep,
  fetchTabList,
  fetchAllSpeakers,
  fetchUserInterests,
  fetchAllTickets,
  fetchAllUnpublishedCourses,
})(CourseWizard);
